<script setup>
import { computed, onMounted, getCurrentInstance } from 'vue';
import FormNavAndForm from '../common/form/FormNavAndForm';
import FormHeader from '../common/form/FormHeader';

const props = defineProps({
    // Add props here if they are passed from the router/parent
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const id = 1;
const tableName = 'account_settings';
const formId = `form:${tableName}:${id}`;

// --- Computed ---

/**
 * Check if the dynamic Vuex module for this settings form exists.
 */
const formExists = computed(() => {
    return !!store.state[formId];
});

// --- Lifecycle ---

onMounted(() => {
    // 1. Update global navigation state
    store.commit('navigationComponent', 'account_settings');

    // 2. Initialize the form module
    store.dispatch('forms/createForm', {
        tableName: tableName,
        id: id
    });
});
</script>

<template>
    <div class="d-flex h-100 overflow-auto flex-column">
        <template v-if="formExists">
            <FormHeader :form-id="formId" :show-save-btn="true"/>

            <FormNavAndForm :form-id="formId" class="flex-grow-1"/>
        </template>

        <div v-else class="flex-grow-1 d-flex align-items-center justify-content-center">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>
    </div>
</template>